// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../ui/styles/tavern-components.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Groups Dashboard - Tavern Theme ========== */

.groups-dashboard {
  padding: var(--space-4);
  max-width: 960px;
  margin: 0 auto;
}

.groups-dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
}

.groups-dashboard-title {
  font-family: var(--font-heading);
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-bold);
  color: var(--color-fire-600);
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.groups-create-button {
  background: var(--color-fire-600);
  color: var(--color-parchment-100);
  border: none;
  border-radius: var(--radius-lg);
  padding: var(--space-3) var(--space-4);
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: 0 2px 4px rgba(26, 20, 16, 0.2);
}

.groups-create-button:hover {
  background: var(--color-fire-700);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(26, 20, 16, 0.3);
}

.groups-create-button:active {
  transform: translateY(0);
}

/* Search Box (from prototype) */
.groups-search,
.search-box {
  background: var(--color-wood-800);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  padding: var(--space-3) var(--space-4);
  margin-bottom: var(--space-4);
  display: flex;
  align-items: center;
  gap: var(--space-3);
  transition: all var(--transition-fast);
}

.groups-search:focus-within,
.search-box:focus-within {
  border-color: var(--color-fire-600);
  box-shadow: 0 0 0 3px rgba(184, 71, 14, 0.2);
}

.groups-search-icon,
.search-icon {
  font-size: 20px;
  color: var(--color-parchment-300);
  flex-shrink: 0;
}

.groups-search-input,
.search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--color-parchment-100);
  padding: var(--space-2) 0;
}

.groups-search-input::placeholder,
.search-input::placeholder {
  color: var(--color-parchment-300);
}

.groups-search-clear {
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  border-radius: var(--radius-full);
  color: var(--color-parchment-300);
  font-size: 16px;
  cursor: pointer;
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
}

.groups-search-clear:hover {
  background: var(--color-danger-500);
  color: var(--color-parchment-100);
}

/* Group Card */
.group-card,
.squad-card {
  background: var(--color-parchment-100);
  
  /* Текстура пергамента из прототипа */
  background-image: 
    radial-gradient(
      circle at 20% 30%,
      rgba(139, 69, 19, 0.12) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(160, 82, 45, 0.08) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 50% 50%,
      rgba(210, 180, 140, 0.15) 0%,
      transparent 80%
    ),
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 2px,
      rgba(139, 69, 19, 0.06) 2px,
      rgba(139, 69, 19, 0.06) 3px
    ),
    repeating-linear-gradient(
      90deg,
      transparent,
      transparent 100px,
      rgba(160, 82, 45, 0.03) 100px,
      rgba(160, 82, 45, 0.03) 101px
    );
  
  border: 3px solid var(--color-wood-700);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-card);
  padding: var(--space-4);
  margin-bottom: var(--space-4);
  transition: all var(--transition-normal) ease-out;
  animation: fade-in-up 400ms ease-out backwards;
}

.group-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-card-hover);
}

.group-card:nth-child(1) {
  animation-delay: 50ms;
}
.group-card:nth-child(2) {
  animation-delay: 100ms;
}
.group-card:nth-child(3) {
  animation-delay: 150ms;
}
.group-card:nth-child(4) {
  animation-delay: 200ms;
}
.group-card:nth-child(5) {
  animation-delay: 250ms;
}

/* Group Header */
.group-card-header,
.squad-header {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  margin-bottom: var(--space-2);
  position: relative;
}

.group-emblem,
.squad-emblem {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, var(--color-wood-700), var(--color-wood-600));
  border: 3px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  box-shadow: 0 2px 8px rgba(26, 20, 16, 0.3), inset 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  flex-shrink: 0;
}

/* Emblem types */
.group-emblem--dnd::before {
  content: '🎲';
}
.group-emblem--warhammer::before {
  content: '⚔️';
}
.group-emblem--boardgames::before {
  content: '🎯';
}
.group-emblem--fencing::before {
  content: '🤺';
}
.group-emblem--default::before {
  content: '🛡️';
}

.group-card-info,
.squad-info {
  flex: 1;
  min-width: 0;
}

.group-card-actions {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: var(--space-2);
  flex-shrink: 0;
}

/* Circular action buttons */
.group-invite-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid var(--color-fire-700);
  background: linear-gradient(135deg, var(--color-fire-100), var(--color-fire-200));
  color: var(--color-fire-800);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 6px rgba(179, 111, 66, 0.35);
}

.group-invite-btn:hover {
  background: linear-gradient(135deg, var(--color-fire-200), var(--color-fire-300));
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(212, 129, 74, 0.5);
}

.group-invite-btn:active {
  transform: translateY(0);
}

.group-invite-btn svg {
  fill: var(--color-fire-700);
}

.group-edit-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid var(--color-wood-600);
  background: linear-gradient(135deg, #f5ede3, #e8dcc8);
  color: var(--color-wood-900);
  font-size: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);
}

.group-edit-btn:hover {
  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(109, 76, 41, 0.5);
}

.group-edit-btn:active {
  transform: translateY(0);
}

.group-delete-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #e96609;
  background: linear-gradient(135deg, #f7e8dd, #f0d9c5);
  color: #000000;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 6px rgba(139, 76, 41, 0.35);
}

.group-delete-btn:hover {
  background: linear-gradient(135deg, #f0d9c5, #e8cbb0);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(139, 76, 41, 0.5);
}

.group-delete-btn:active {
  transform: translateY(0);
}

.group-card-title-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding-right: 110px;
}

.group-card-title,
.squad-name {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-fire-600);
  margin: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.group-visibility-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  font-family: var(--font-heading);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  flex-shrink: 0;
  align-self: flex-start;
}

.group-visibility-open {
  background: linear-gradient(135deg, #f5e8d3 0%, #e8d5b7 100%);
  border: 2px solid #c4a570;
  color: #6d4c29;
  box-shadow: 0 1px 3px rgba(109, 76, 41, 0.2);
}

.group-visibility-private {
  background: linear-gradient(135deg, var(--color-wood-700), var(--color-wood-600));
  border: 2px solid var(--color-wood-700);
  color: var(--color-parchment-100);
  box-shadow: 0 1px 3px rgba(26, 20, 16, 0.3);
}

/* Join button in badge style */
button.group-join-badge-btn,
button.group-join-badge-btn:link,
button.group-join-badge-btn:visited {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  font-family: var(--font-heading);
  white-space: nowrap;
  background: linear-gradient(135deg, var(--color-fire-600), var(--color-fire-700)) !important;
  border: 2px solid var(--color-fire-700) !important;
  color: var(--color-parchment-100) !important;
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: 0 1px 3px rgba(184, 71, 14, 0.3);
  outline: none !important;
  text-decoration: none !important;
}

button.group-join-badge-btn:hover {
  background: linear-gradient(135deg, var(--color-fire-700), var(--color-fire-800)) !important;
  color: var(--color-parchment-100) !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(184, 71, 14, 0.4);
}

button.group-join-badge-btn:active {
  transform: translateY(0);
  background: linear-gradient(135deg, var(--color-fire-700), var(--color-fire-800)) !important;
  color: var(--color-parchment-100) !important;
  border: 2px solid var(--color-fire-700) !important;
  outline: none !important;
}

button.group-join-badge-btn:focus,
button.group-join-badge-btn:focus-visible {
  outline: none !important;
  background: linear-gradient(135deg, var(--color-fire-600), var(--color-fire-700)) !important;
  color: var(--color-parchment-100) !important;
  border: 2px solid var(--color-fire-700) !important;
}

.group-join-badge-btn .join-icon {
  color: #4ade80;
  font-size: 20px;
  font-weight: 900;
  line-height: 1;
}

.group-card-organizer,
.squad-organizer {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin-bottom: var(--space-1);
}

.group-card-organizer-name {
  font-weight: var(--font-weight-semibold);
  color: var(--color-fire-600);
  cursor: pointer;
  text-decoration: none;
}

.group-card-organizer-name:hover {
  text-decoration: underline;
}

/* Member Count */
.group-card-member-count,
.squad-member-count {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-fire-600);
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin-top: 2px;
}

.group-card-member-count-separator {
  color: var(--color-text-secondary);
  opacity: 0.5;
}

.group-card-member-count-pending {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-warning-600);
}

@media (max-width: 425px) {
  .group-card-header {
    display: grid;
    grid-template-columns: 44px 1fr auto;
    grid-template-rows: auto auto;
    grid-template-areas:
      "emblem title title"
      "emblem members actions";
    gap: 8px 10px;
    align-items: center;
  }

  .group-card-info {
    display: contents;
  }

  .group-emblem {
    grid-area: emblem;
    width: 44px;
    height: 44px;
    font-size: 24px;
    border-width: 2px;
  }

  .group-card-title-row {
    grid-area: title;
    padding-right: 0;
    gap: 4px;
    flex-wrap: wrap;
  }

  .group-card-title {
    margin: 0;
    padding-right: 0;
    font-size: 16px;
    flex-basis: 100%;
  }

  .group-visibility-badge {
    font-size: 9px;
    padding: 2px 6px;
    border-radius: 8px;
  }

  .group-join-badge-btn {
    font-size: 9px;
    padding: 2px 8px;
    border-radius: 8px;
    margin-left: auto;
  }

  .group-card-member-count {
    grid-area: members;
    font-size: 12px;
    gap: 6px;
  }

  .group-card-member-count-text {
    display: none;
  }

  .group-card-actions {
    grid-area: actions;
    position: static;
    justify-self: end;
    gap: 6px;
  }

  .group-invite-btn,
  .group-edit-btn,
  .group-delete-btn {
    width: 32px;
    height: 32px;
    border-width: 1px;
  }

  .group-invite-btn svg {
    width: 18px;
    height: 18px;
  }

  .group-edit-btn {
    font-size: 16px;
  }

  .group-delete-btn {
    font-size: 14px;
  }
}

/* Leader section */
.group-card-leader-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin-bottom: var(--space-1);
  padding: var(--space-2) var(--space-3);
  background: linear-gradient(135deg, #fef9f3 0%, #f9f0e6 100%);
  border-radius: 12px;
  border: 2px solid var(--color-fire-500);
  box-shadow: 0 2px 8px rgba(212, 129, 74, 0.25);
}

.leader-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--color-fire-700);
  font-family: var(--font-heading);
}

.leader-item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.leader-icon {
  font-size: 24px;
  line-height: 1;
  flex-shrink: 0;
}

.leader-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-fire-600);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.leader-name:hover {
  color: var(--color-fire-700);
  text-decoration: underline;
}

/* Description section - styled like leader section */
.group-card-description-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin-bottom: var(--space-1);
  padding: var(--space-2) var(--space-3);
  background: linear-gradient(135deg, #f5efe6 0%, #ebe3d6 100%);
  border-radius: 12px;
  border: 2px solid var(--color-wood-600);
  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.2);
}

.description-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--color-wood-800);
  font-family: var(--font-heading);
}

.description-content {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
}

.description-icon {
  font-size: 20px;
  line-height: 1.4;
  flex-shrink: 0;
}

.description-text {
  font-size: 14px;
  color: var(--color-text-primary);
  line-height: 1.6;
  font-style: italic;
}

/* Legacy description (for squad-description compatibility) */
.squad-description {
  font-size: 14px;
  color: var(--color-text-primary);
  line-height: 1.6;
  padding: var(--space-3);
  background: linear-gradient(135deg, rgba(245, 233, 217, 0.4) 0%, rgba(249, 240, 230, 0.4) 100%);
  border-radius: 10px;
  border: 1px solid var(--color-wood-500);
  margin-bottom: var(--space-4);
  font-style: italic;
  box-shadow: inset 0 1px 3px rgba(139, 69, 19, 0.1);
}

/* Members */
.group-card-members,
.squad-members {
  padding-top: var(--space-3);
  border-top: 1px solid var(--color-wood-600);
  margin-top: var(--space-3);
}

.group-card-members-title,
.squad-members-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-secondary);
  margin-bottom: var(--space-2);
}

.group-card-members-list,
.member-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.group-member-item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 12px 16px;
  border-radius: 12px;
  transition: all var(--transition-fast);
}

.group-member-item--confirmed {
  border: 2px solid var(--color-wood-800);
  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);
  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);
}

.group-member-item--pending {
  border: 2px solid var(--color-warning-600);
  background: linear-gradient(135deg, #fdf8ed 0%, #fef5e7 100%);
  box-shadow: 0 2px 8px rgba(212, 167, 74, 0.2);
}

.group-member-status-icon {
  font-size: 20px;
  line-height: 1;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(109, 76, 41, 0.15);
  border-radius: 50%;
  border: 2px solid var(--color-wood-700);
  color: var(--color-wood-900);
  font-weight: 900;
}

.group-member-name {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text-primary);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.group-member-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}

a.group-member-name:hover {
  color: var(--color-fire-600);
  text-decoration: underline;
}

.group-member-remove-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #8b2e0b;
  background: linear-gradient(135deg, #c53030, #a02020);
  color: #ffffff;
  font-size: 18px;
  font-weight: 900;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  flex-shrink: 0;
  line-height: 1;
  padding: 0;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}

.group-member-remove-btn:hover {
  background: linear-gradient(135deg, #9b2c2c, #7a1d1d);
  transform: scale(1.1);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.5);
}

.group-member-remove-btn:active {
  transform: scale(0.95);
}

/* Action buttons for participants */
.participant-action-btn {
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-wood-900);
  background: #c4a570;
  border: 2px solid var(--color-wood-700);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: var(--font-heading);
  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);
  margin-left: 0;
}

.participant-action-btn:hover {
  background: var(--color-danger-100);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(168, 52, 42, 0.3);
}

.participant-action-btn--confirm {
  color: var(--color-nature-900);
  border-color: var(--color-nature-500);
  background: #268d49;
  box-shadow: 0 2px 4px rgba(30, 105, 52, 0.3);
}

.participant-action-btn--confirm:hover {
  background: #166b32;
  box-shadow: 0 4px 8px rgba(8, 63, 24, 0.3);
}

.participant-action-btn--leave {
  border-color: var(--color-wood-600);
  background: linear-gradient(135deg, #f5ede3, #e8dcc8);
  color: var(--color-wood-900);
}

.participant-action-btn--leave:hover {
  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);
}

@media (max-width: 425px) {
  .group-member-actions {
    gap: 6px;
  }

  .participant-action-btn {
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 50%;
    border-width: 1px;
    font-size: 14px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

a.group-member-item:hover {
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(26, 20, 16, 0.15);
}

.group-member-more {
  color: var(--color-text-secondary);
  font-style: italic;
  cursor: default;
}

/* Pagination */
.groups-pagination {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin-top: var(--space-5);
  padding: var(--space-4);
  background: var(--color-wood-800);
  border-radius: var(--radius-lg);
  border: 2px solid var(--color-wood-700);
}

.groups-pagination-info {
  flex: 1;
  text-align: center;
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  color: var(--color-parchment-200);
  font-variant-numeric: tabular-nums;
}

/* Empty/Loading states */
.groups-content {
  min-height: 300px;
}

/* Page-specific styles for GroupsDashboardPage */

.ttbMt8 {
  margin-top: 8px;
}

.ttbRowGap8 {
  gap: 8px;
}

.ttbSmallLabel {
  color: var(--app-hint);
  font-size: 12px;
  font-weight: 700;
}

.ttbGroupName {
  font-size: 15px;
  font-weight: 900;
}

.ttbGroupDescription {
  color: var(--app-hint);
  font-size: 13px;
  line-height: 1.35;
}

.ttbLinkStrong {
  font-size: 13px;
  font-weight: 700;
}

.ttbMembersList {
  display: grid;
  gap: 8px;
  max-height: 220px;
  overflow: auto;
  padding-right: 4px;
}

@media (min-width: 768px) {
  .ttbMembersList {
    max-height: 360px;
  }
}

.ttbMemberLink {
  height: 44px;
  border-radius: 10px;
  border: 2px solid var(--app-separator);
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  padding: 0 12px;
  color: var(--app-link);
  font-weight: 700;
  text-decoration: none;
}

.ttbMemberConfirmed {
  border-color: var(--app-success);
}

.ttbMemberPending {
  border-color: var(--app-warning);
}

.ttbMemberStatus {
  color: var(--app-hint);
  font-size: 12px;
  font-weight: 800;
}


/* Desktop: карточки отрядов в сетку */
@media (min-width: 768px) {
  .groups-content {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-4);
    align-items: start;
  }

  .groups-content > * {
    grid-column: 1 / -1;
  }

  .groups-content > .group-card {
    grid-column: auto;
    margin-bottom: 0;
  }
}

@media (min-width: 1024px) {
  .groups-dashboard {
    max-width: var(--content-max);
    padding: var(--space-6) var(--space-7);
  }

  .groups-content {
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  }
}

/* ---------- Wide layout: leader and description on the left, members on the right ---------- */

/* Контейнер — только обёртка тела (не сама карточка), чтобы не ломать fixed-потомков */
.group-card-bodywrap {
  container-type: inline-size;
  container-name: group-card;
}

.group-card-col > :last-child {
  margin-bottom: 0;
}

@container group-card (min-width: 720px) {
  .group-card-body {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: var(--space-5);
    align-items: start;
  }
}

/* Действия встают в строку заголовка, а не накладываются на название */
@media (min-width: 768px) {
  .group-card-actions {
    position: static;
    margin-left: auto;
  }

  .group-card-title-row {
    padding-right: 0;
  }
}

@media (min-width: 1024px) {
  .groups-content {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/GroupsDashboard/GroupsDashboardPage.css"],"names":[],"mappings":"AAGA,0DAA0D;;AAE1D;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;;EAEE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;;EAEE,eAAe;EACf,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;EAEE,OAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;EACjC,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA,eAAe;AACf;;EAEE,sCAAsC;;EAEtC,qCAAqC;EACrC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA6BG;;EAEH,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,uCAAuC;EACvC,+BAA+B;EAC/B,+EAA+E;EAC/E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,iFAAiF;EACjF,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,iFAAiF;EACjF,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,qDAAqD;EACrD,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,iFAAiF;EACjF,uCAAuC;EACvC,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA,+BAA+B;AAC/B;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,4FAA4F;EAC5F,kDAAkD;EAClD,4CAA4C;EAC5C,eAAe;EACf,sCAAsC;EACtC,4CAA4C;EAC5C,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,4FAA4F;EAC5F,4CAA4C;EAC5C,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,4FAA4F;EAC5F,4CAA4C;EAC5C,kDAAkD;EAClD,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,4FAA4F;EAC5F,4CAA4C;EAC5C,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;;EAEE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE;IACE,aAAa;IACb,oCAAoC;IACpC,6BAA6B;IAC7B;;8BAE0B;IAC1B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;;;IAGE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,sCAAsC;EACtC,6DAA6D;EAC7D,mBAAmB;EACnB,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,sCAAsC;EACtC,6DAA6D;EAC7D,mBAAmB;EACnB,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,+FAA+F;EAC/F,mBAAmB;EACnB,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA,YAAY;AACZ;;EAEE,2BAA2B;EAC3B,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;EACd,cAAc;EACd,UAAU;EACV,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,iCAAiC;EACjC,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;AACnB;;AAEA,iDAAiD;;AAEjD;EACE,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;;AAGA,sCAAsC;AACtC;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,sCAAsC;EACxC;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA,gGAAgG;;AAEhG,uFAAuF;AACvF;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,oDAAoD;IACpD,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA,uEAAuE;AACvE;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["@import '../_base.css';\n@import '../../ui/styles/tavern-components.css';\n\n/* ========== Groups Dashboard - Tavern Theme ========== */\n\n.groups-dashboard {\n  padding: var(--space-4);\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.groups-dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  margin-bottom: var(--space-4);\n}\n\n.groups-dashboard-title {\n  font-family: var(--font-heading);\n  font-size: var(--font-size-h1);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-fire-600);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.groups-create-button {\n  background: var(--color-fire-600);\n  color: var(--color-parchment-100);\n  border: none;\n  border-radius: var(--radius-lg);\n  padding: var(--space-3) var(--space-4);\n  font-family: var(--font-body);\n  font-size: 14px;\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: 0 2px 4px rgba(26, 20, 16, 0.2);\n}\n\n.groups-create-button:hover {\n  background: var(--color-fire-700);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(26, 20, 16, 0.3);\n}\n\n.groups-create-button:active {\n  transform: translateY(0);\n}\n\n/* Search Box (from prototype) */\n.groups-search,\n.search-box {\n  background: var(--color-wood-800);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  padding: var(--space-3) var(--space-4);\n  margin-bottom: var(--space-4);\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  transition: all var(--transition-fast);\n}\n\n.groups-search:focus-within,\n.search-box:focus-within {\n  border-color: var(--color-fire-600);\n  box-shadow: 0 0 0 3px rgba(184, 71, 14, 0.2);\n}\n\n.groups-search-icon,\n.search-icon {\n  font-size: 20px;\n  color: var(--color-parchment-300);\n  flex-shrink: 0;\n}\n\n.groups-search-input,\n.search-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--font-body);\n  font-size: 14px;\n  color: var(--color-parchment-100);\n  padding: var(--space-2) 0;\n}\n\n.groups-search-input::placeholder,\n.search-input::placeholder {\n  color: var(--color-parchment-300);\n}\n\n.groups-search-clear {\n  width: 24px;\n  height: 24px;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-full);\n  color: var(--color-parchment-300);\n  font-size: 16px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.groups-search-clear:hover {\n  background: var(--color-danger-500);\n  color: var(--color-parchment-100);\n}\n\n/* Group Card */\n.group-card,\n.squad-card {\n  background: var(--color-parchment-100);\n  \n  /* Текстура пергамента из прототипа */\n  background-image: \n    radial-gradient(\n      circle at 20% 30%,\n      rgba(139, 69, 19, 0.12) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 80% 70%,\n      rgba(160, 82, 45, 0.08) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 50% 50%,\n      rgba(210, 180, 140, 0.15) 0%,\n      transparent 80%\n    ),\n    repeating-linear-gradient(\n      0deg,\n      transparent,\n      transparent 2px,\n      rgba(139, 69, 19, 0.06) 2px,\n      rgba(139, 69, 19, 0.06) 3px\n    ),\n    repeating-linear-gradient(\n      90deg,\n      transparent,\n      transparent 100px,\n      rgba(160, 82, 45, 0.03) 100px,\n      rgba(160, 82, 45, 0.03) 101px\n    );\n  \n  border: 3px solid var(--color-wood-700);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-card);\n  padding: var(--space-4);\n  margin-bottom: var(--space-4);\n  transition: all var(--transition-normal) ease-out;\n  animation: fade-in-up 400ms ease-out backwards;\n}\n\n.group-card:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-card-hover);\n}\n\n.group-card:nth-child(1) {\n  animation-delay: 50ms;\n}\n.group-card:nth-child(2) {\n  animation-delay: 100ms;\n}\n.group-card:nth-child(3) {\n  animation-delay: 150ms;\n}\n.group-card:nth-child(4) {\n  animation-delay: 200ms;\n}\n.group-card:nth-child(5) {\n  animation-delay: 250ms;\n}\n\n/* Group Header */\n.group-card-header,\n.squad-header {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  margin-bottom: var(--space-2);\n  position: relative;\n}\n\n.group-emblem,\n.squad-emblem {\n  width: 56px;\n  height: 56px;\n  background: linear-gradient(135deg, var(--color-wood-700), var(--color-wood-600));\n  border: 3px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 2px 8px rgba(26, 20, 16, 0.3), inset 0 2px 4px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  flex-shrink: 0;\n}\n\n/* Emblem types */\n.group-emblem--dnd::before {\n  content: '🎲';\n}\n.group-emblem--warhammer::before {\n  content: '⚔️';\n}\n.group-emblem--boardgames::before {\n  content: '🎯';\n}\n.group-emblem--fencing::before {\n  content: '🤺';\n}\n.group-emblem--default::before {\n  content: '🛡️';\n}\n\n.group-card-info,\n.squad-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.group-card-actions {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  gap: var(--space-2);\n  flex-shrink: 0;\n}\n\n/* Circular action buttons */\n.group-invite-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid var(--color-fire-700);\n  background: linear-gradient(135deg, var(--color-fire-100), var(--color-fire-200));\n  color: var(--color-fire-800);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  box-shadow: 0 2px 6px rgba(179, 111, 66, 0.35);\n}\n\n.group-invite-btn:hover {\n  background: linear-gradient(135deg, var(--color-fire-200), var(--color-fire-300));\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(212, 129, 74, 0.5);\n}\n\n.group-invite-btn:active {\n  transform: translateY(0);\n}\n\n.group-invite-btn svg {\n  fill: var(--color-fire-700);\n}\n\n.group-edit-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid var(--color-wood-600);\n  background: linear-gradient(135deg, #f5ede3, #e8dcc8);\n  color: var(--color-wood-900);\n  font-size: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);\n}\n\n.group-edit-btn:hover {\n  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(109, 76, 41, 0.5);\n}\n\n.group-edit-btn:active {\n  transform: translateY(0);\n}\n\n.group-delete-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid #e96609;\n  background: linear-gradient(135deg, #f7e8dd, #f0d9c5);\n  color: #000000;\n  font-size: 18px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  box-shadow: 0 2px 6px rgba(139, 76, 41, 0.35);\n}\n\n.group-delete-btn:hover {\n  background: linear-gradient(135deg, #f0d9c5, #e8cbb0);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(139, 76, 41, 0.5);\n}\n\n.group-delete-btn:active {\n  transform: translateY(0);\n}\n\n.group-card-title-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding-right: 110px;\n}\n\n.group-card-title,\n.squad-name {\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-fire-600);\n  margin: 0;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.group-visibility-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 3px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  font-family: var(--font-heading);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n  flex-shrink: 0;\n  align-self: flex-start;\n}\n\n.group-visibility-open {\n  background: linear-gradient(135deg, #f5e8d3 0%, #e8d5b7 100%);\n  border: 2px solid #c4a570;\n  color: #6d4c29;\n  box-shadow: 0 1px 3px rgba(109, 76, 41, 0.2);\n}\n\n.group-visibility-private {\n  background: linear-gradient(135deg, var(--color-wood-700), var(--color-wood-600));\n  border: 2px solid var(--color-wood-700);\n  color: var(--color-parchment-100);\n  box-shadow: 0 1px 3px rgba(26, 20, 16, 0.3);\n}\n\n/* Join button in badge style */\nbutton.group-join-badge-btn,\nbutton.group-join-badge-btn:link,\nbutton.group-join-badge-btn:visited {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 3px 10px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  font-family: var(--font-heading);\n  white-space: nowrap;\n  background: linear-gradient(135deg, var(--color-fire-600), var(--color-fire-700)) !important;\n  border: 2px solid var(--color-fire-700) !important;\n  color: var(--color-parchment-100) !important;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: 0 1px 3px rgba(184, 71, 14, 0.3);\n  outline: none !important;\n  text-decoration: none !important;\n}\n\nbutton.group-join-badge-btn:hover {\n  background: linear-gradient(135deg, var(--color-fire-700), var(--color-fire-800)) !important;\n  color: var(--color-parchment-100) !important;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(184, 71, 14, 0.4);\n}\n\nbutton.group-join-badge-btn:active {\n  transform: translateY(0);\n  background: linear-gradient(135deg, var(--color-fire-700), var(--color-fire-800)) !important;\n  color: var(--color-parchment-100) !important;\n  border: 2px solid var(--color-fire-700) !important;\n  outline: none !important;\n}\n\nbutton.group-join-badge-btn:focus,\nbutton.group-join-badge-btn:focus-visible {\n  outline: none !important;\n  background: linear-gradient(135deg, var(--color-fire-600), var(--color-fire-700)) !important;\n  color: var(--color-parchment-100) !important;\n  border: 2px solid var(--color-fire-700) !important;\n}\n\n.group-join-badge-btn .join-icon {\n  color: #4ade80;\n  font-size: 20px;\n  font-weight: 900;\n  line-height: 1;\n}\n\n.group-card-organizer,\n.squad-organizer {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--space-1);\n}\n\n.group-card-organizer-name {\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-fire-600);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.group-card-organizer-name:hover {\n  text-decoration: underline;\n}\n\n/* Member Count */\n.group-card-member-count,\n.squad-member-count {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-fire-600);\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  margin-top: 2px;\n}\n\n.group-card-member-count-separator {\n  color: var(--color-text-secondary);\n  opacity: 0.5;\n}\n\n.group-card-member-count-pending {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-warning-600);\n}\n\n@media (max-width: 425px) {\n  .group-card-header {\n    display: grid;\n    grid-template-columns: 44px 1fr auto;\n    grid-template-rows: auto auto;\n    grid-template-areas:\n      \"emblem title title\"\n      \"emblem members actions\";\n    gap: 8px 10px;\n    align-items: center;\n  }\n\n  .group-card-info {\n    display: contents;\n  }\n\n  .group-emblem {\n    grid-area: emblem;\n    width: 44px;\n    height: 44px;\n    font-size: 24px;\n    border-width: 2px;\n  }\n\n  .group-card-title-row {\n    grid-area: title;\n    padding-right: 0;\n    gap: 4px;\n    flex-wrap: wrap;\n  }\n\n  .group-card-title {\n    margin: 0;\n    padding-right: 0;\n    font-size: 16px;\n    flex-basis: 100%;\n  }\n\n  .group-visibility-badge {\n    font-size: 9px;\n    padding: 2px 6px;\n    border-radius: 8px;\n  }\n\n  .group-join-badge-btn {\n    font-size: 9px;\n    padding: 2px 8px;\n    border-radius: 8px;\n    margin-left: auto;\n  }\n\n  .group-card-member-count {\n    grid-area: members;\n    font-size: 12px;\n    gap: 6px;\n  }\n\n  .group-card-member-count-text {\n    display: none;\n  }\n\n  .group-card-actions {\n    grid-area: actions;\n    position: static;\n    justify-self: end;\n    gap: 6px;\n  }\n\n  .group-invite-btn,\n  .group-edit-btn,\n  .group-delete-btn {\n    width: 32px;\n    height: 32px;\n    border-width: 1px;\n  }\n\n  .group-invite-btn svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  .group-edit-btn {\n    font-size: 16px;\n  }\n\n  .group-delete-btn {\n    font-size: 14px;\n  }\n}\n\n/* Leader section */\n.group-card-leader-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  margin-bottom: var(--space-1);\n  padding: var(--space-2) var(--space-3);\n  background: linear-gradient(135deg, #fef9f3 0%, #f9f0e6 100%);\n  border-radius: 12px;\n  border: 2px solid var(--color-fire-500);\n  box-shadow: 0 2px 8px rgba(212, 129, 74, 0.25);\n}\n\n.leader-label {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--color-fire-700);\n  font-family: var(--font-heading);\n}\n\n.leader-item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.leader-icon {\n  font-size: 24px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.leader-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-fire-600);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.leader-name:hover {\n  color: var(--color-fire-700);\n  text-decoration: underline;\n}\n\n/* Description section - styled like leader section */\n.group-card-description-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  margin-bottom: var(--space-1);\n  padding: var(--space-2) var(--space-3);\n  background: linear-gradient(135deg, #f5efe6 0%, #ebe3d6 100%);\n  border-radius: 12px;\n  border: 2px solid var(--color-wood-600);\n  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.2);\n}\n\n.description-label {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--color-wood-800);\n  font-family: var(--font-heading);\n}\n\n.description-content {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n}\n\n.description-icon {\n  font-size: 20px;\n  line-height: 1.4;\n  flex-shrink: 0;\n}\n\n.description-text {\n  font-size: 14px;\n  color: var(--color-text-primary);\n  line-height: 1.6;\n  font-style: italic;\n}\n\n/* Legacy description (for squad-description compatibility) */\n.squad-description {\n  font-size: 14px;\n  color: var(--color-text-primary);\n  line-height: 1.6;\n  padding: var(--space-3);\n  background: linear-gradient(135deg, rgba(245, 233, 217, 0.4) 0%, rgba(249, 240, 230, 0.4) 100%);\n  border-radius: 10px;\n  border: 1px solid var(--color-wood-500);\n  margin-bottom: var(--space-4);\n  font-style: italic;\n  box-shadow: inset 0 1px 3px rgba(139, 69, 19, 0.1);\n}\n\n/* Members */\n.group-card-members,\n.squad-members {\n  padding-top: var(--space-3);\n  border-top: 1px solid var(--color-wood-600);\n  margin-top: var(--space-3);\n}\n\n.group-card-members-title,\n.squad-members-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--space-2);\n}\n\n.group-card-members-list,\n.member-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.group-member-item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding: 12px 16px;\n  border-radius: 12px;\n  transition: all var(--transition-fast);\n}\n\n.group-member-item--confirmed {\n  border: 2px solid var(--color-wood-800);\n  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);\n  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);\n}\n\n.group-member-item--pending {\n  border: 2px solid var(--color-warning-600);\n  background: linear-gradient(135deg, #fdf8ed 0%, #fef5e7 100%);\n  box-shadow: 0 2px 8px rgba(212, 167, 74, 0.2);\n}\n\n.group-member-status-icon {\n  font-size: 20px;\n  line-height: 1;\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(109, 76, 41, 0.15);\n  border-radius: 50%;\n  border: 2px solid var(--color-wood-700);\n  color: var(--color-wood-900);\n  font-weight: 900;\n}\n\n.group-member-name {\n  flex: 1;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.group-member-actions {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\na.group-member-name:hover {\n  color: var(--color-fire-600);\n  text-decoration: underline;\n}\n\n.group-member-remove-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid #8b2e0b;\n  background: linear-gradient(135deg, #c53030, #a02020);\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 900;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  flex-shrink: 0;\n  line-height: 1;\n  padding: 0;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);\n}\n\n.group-member-remove-btn:hover {\n  background: linear-gradient(135deg, #9b2c2c, #7a1d1d);\n  transform: scale(1.1);\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.5);\n}\n\n.group-member-remove-btn:active {\n  transform: scale(0.95);\n}\n\n/* Action buttons for participants */\n.participant-action-btn {\n  padding: 6px 16px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--color-wood-900);\n  background: #c4a570;\n  border: 2px solid var(--color-wood-700);\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: var(--font-heading);\n  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);\n  margin-left: 0;\n}\n\n.participant-action-btn:hover {\n  background: var(--color-danger-100);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(168, 52, 42, 0.3);\n}\n\n.participant-action-btn--confirm {\n  color: var(--color-nature-900);\n  border-color: var(--color-nature-500);\n  background: #268d49;\n  box-shadow: 0 2px 4px rgba(30, 105, 52, 0.3);\n}\n\n.participant-action-btn--confirm:hover {\n  background: #166b32;\n  box-shadow: 0 4px 8px rgba(8, 63, 24, 0.3);\n}\n\n.participant-action-btn--leave {\n  border-color: var(--color-wood-600);\n  background: linear-gradient(135deg, #f5ede3, #e8dcc8);\n  color: var(--color-wood-900);\n}\n\n.participant-action-btn--leave:hover {\n  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);\n}\n\n@media (max-width: 425px) {\n  .group-member-actions {\n    gap: 6px;\n  }\n\n  .participant-action-btn {\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border-radius: 50%;\n    border-width: 1px;\n    font-size: 14px;\n    line-height: 1;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\na.group-member-item:hover {\n  transform: translateX(2px);\n  box-shadow: 0 2px 8px rgba(26, 20, 16, 0.15);\n}\n\n.group-member-more {\n  color: var(--color-text-secondary);\n  font-style: italic;\n  cursor: default;\n}\n\n/* Pagination */\n.groups-pagination {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  margin-top: var(--space-5);\n  padding: var(--space-4);\n  background: var(--color-wood-800);\n  border-radius: var(--radius-lg);\n  border: 2px solid var(--color-wood-700);\n}\n\n.groups-pagination-info {\n  flex: 1;\n  text-align: center;\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  color: var(--color-parchment-200);\n  font-variant-numeric: tabular-nums;\n}\n\n/* Empty/Loading states */\n.groups-content {\n  min-height: 300px;\n}\n\n/* Page-specific styles for GroupsDashboardPage */\n\n.ttbMt8 {\n  margin-top: 8px;\n}\n\n.ttbRowGap8 {\n  gap: 8px;\n}\n\n.ttbSmallLabel {\n  color: var(--app-hint);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.ttbGroupName {\n  font-size: 15px;\n  font-weight: 900;\n}\n\n.ttbGroupDescription {\n  color: var(--app-hint);\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.ttbLinkStrong {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.ttbMembersList {\n  display: grid;\n  gap: 8px;\n  max-height: 220px;\n  overflow: auto;\n  padding-right: 4px;\n}\n\n@media (min-width: 768px) {\n  .ttbMembersList {\n    max-height: 360px;\n  }\n}\n\n.ttbMemberLink {\n  height: 44px;\n  border-radius: 10px;\n  border: 2px solid var(--app-separator);\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  padding: 0 12px;\n  color: var(--app-link);\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.ttbMemberConfirmed {\n  border-color: var(--app-success);\n}\n\n.ttbMemberPending {\n  border-color: var(--app-warning);\n}\n\n.ttbMemberStatus {\n  color: var(--app-hint);\n  font-size: 12px;\n  font-weight: 800;\n}\n\n\n/* Desktop: карточки отрядов в сетку */\n@media (min-width: 768px) {\n  .groups-content {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--space-4);\n    align-items: start;\n  }\n\n  .groups-content > * {\n    grid-column: 1 / -1;\n  }\n\n  .groups-content > .group-card {\n    grid-column: auto;\n    margin-bottom: 0;\n  }\n}\n\n@media (min-width: 1024px) {\n  .groups-dashboard {\n    max-width: var(--content-max);\n    padding: var(--space-6) var(--space-7);\n  }\n\n  .groups-content {\n    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  }\n}\n\n/* ---------- Wide layout: leader and description on the left, members on the right ---------- */\n\n/* Контейнер — только обёртка тела (не сама карточка), чтобы не ломать fixed-потомков */\n.group-card-bodywrap {\n  container-type: inline-size;\n  container-name: group-card;\n}\n\n.group-card-col > :last-child {\n  margin-bottom: 0;\n}\n\n@container group-card (min-width: 720px) {\n  .group-card-body {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    column-gap: var(--space-5);\n    align-items: start;\n  }\n}\n\n/* Действия встают в строку заголовка, а не накладываются на название */\n@media (min-width: 768px) {\n  .group-card-actions {\n    position: static;\n    margin-left: auto;\n  }\n\n  .group-card-title-row {\n    padding-right: 0;\n  }\n}\n\n@media (min-width: 1024px) {\n  .groups-content {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
